import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";
import shadowImg from "../assets/images/btn_shadow.png";
import "../assets/css/index.css"



export default function Header() {
	return (
		<header className="header homepage-area">
			<div className="container py-6 md:py-10 flex justify-between items-center">
				<Link to="/#" className="logo_cont flex items-center gap-2">
					<img src={logo} alt="" />
					<div className="faded_txt ">Fl-Dating.Su</div>
				</Link>
		<div className="flex gap-4 md:gap-10 items-center">
		  <Link to={"https://fl-dating.su/login"} style={{color: "white"}}>Вход</Link>
		  <Link to={"https://fl-dating.su/register"} className="pink_btn gradient-border" style={{ backgroundImage: `url(${shadowImg})` }}>
			<span className="faded_txt">Регистрация</span>
		  </Link>
		</div>
			</div>
		</header>
	);
}
